/**
 * Garante que só um áudio toca por vez na aplicação.
 *
 * Singleton de módulo pelo mesmo motivo do registro de pendentes do mediaStorage:
 * os players são criados e destruídos pelos v-for das listas, e nenhum deles tem
 * como conhecer os outros. No iOS isso não é refinamento — aparelhos antigos
 * decodificam um elemento de mídia por vez.
 */
let current: HTMLAudioElement | null = null

/**
 * Toca, pausando quem estiver tocando. Sem `await` antes do play() de propósito:
 * no iOS Safari qualquer ponto de suspensão consome o gesto do usuário e o play()
 * passa a ser recusado. Por isso o src tem de estar no template, e esta função é
 * chamada direto do handler do clique.
 */
export function play(element: HTMLAudioElement) {
    if (current && current !== element) current.pause()
    current = element
    //play() rejeita com AbortError quando um pause() a interrompe — que é
    //exatamente o que a linha acima faz. Sem o catch o console enche de
    //unhandled rejection sem nada de errado ter acontecido.
    const started = element.play()
    if (started && started.catch) started.catch(() => undefined)
}

export function pause(element: HTMLAudioElement) {
    element.pause()
    if (current === element) current = null
}

/** Quem sabe que o elemento vai embora é quem solta — mesma doutrina do revoke. */
export function release(element: HTMLAudioElement) {
    if (current === element) current = null
}

export default {play, pause, release}
